import React, { useState, useEffect } from "react";
import { FaHeart, FaTimes, FaMapMarkerAlt, FaBriefcase, FaUser } from "react-icons/fa"; 
import { Link } from "react-router-dom";
import ProfileSidebar from "../component/ProfileSidebar";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl";
import { getStoredToken } from "../component/utils/getStoredToken";
import BottomMenu from "../component/BottomMenu";
import FooterTwo from "../component/FooterTwo";
import NavigateHome from "../component/utils/NavigateHome";

import male from "../assets/img/male.png";
import female from "../assets/img/female.png";
import PageCount from "../component/utils/PageCount";
import PartnerCardsMobile from "../component/PartnerCardsMobile";


function PartnerCards() {
  const token = getStoredToken();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true); // loading state

  // console.log("token", token);

  useEffect(() => {
    const fetchMatches = async () => {
      if (!token) return;

      try {
        setLoading(true);
        const res = await axios.get(`${baseurl}getMatchedUsers`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data.success) {
          const matches = res.data.matches.map((p) => ({
            id: p.id,
            uid: p.uid,
            display_id: p.display_id,
            name: `${p.first_name} ${p.last_name}`,
            age: Math.floor((new Date() - new Date(p.date_of_birth)) / (1000 * 60 * 60 * 24 * 365)),
            // height: p.height ? `${(p.height / 30.48).toFixed(1)}'` : "N/A", 
            height: p.height , 
            city: p.location || "N/A", 
            current_occupation: p.current_occupation || "N/A",
            annual_income: p.annual_income ? `${p.annual_income} Lacs p.a` : "No Income",
            profession: p.profession || "N/A",
            religion: p.religion || "N/A",
            gender: p.gender || "N/A",
           image: p.main_photo
  ? `${imgurl}${p.main_photo}`
  : p.gender?.toLowerCase() === "female"
    ? female
    : male,
          }));
          setProfiles(matches);
        }
      } catch (err) {
        console.error("Error fetching matches:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, [token]);

  // Skeleton Loader
  const renderSkeletons = () => {
    const skeletons = Array.from({ length: 10 }); // 10 placeholders
    return skeletons.map((_, idx) => (
      <div key={idx} className="col">
        <div className="card h-100 border-0 shadow-sm profile-card overflow-hidden p-1">
          <div className="profile-image-wrapper position-relative">
            <div className="skeleton-img"></div>
            <div className="skeleton-overlay mt-1"></div>
          </div>
          <div className="profile-details text-center mt-2">
            <div className="skeleton-btn"></div>
          </div>
        </div>
      </div>
    ));
  };

  return (


    <>
    
    <NavigateHome/>
    <PageCount pageName = {"Partner Cards Page"}/>






    <div className="base-section container-fluid py-2 d-none d-lg-block">
      <ProfileSidebar/>
      <div className="base-container">
        {/* <h2 className=" card-ttl mb-2 text-start">Recommended Profile</h2> */}

        <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-3">
          {loading
            ? renderSkeletons()
            : profiles.length > 0 
              ? profiles.map((p) => (
                  <div key={p.id} className="col">
                    <Link to={`/profile/view/${p.uid}`} >
                   
                    <div className="card h-100 border-0 shadow-sm profile-card overflow-hidden p-1">
                      <div className="profile-image-wrapper position-relative">
                        <img src={p.image} alt={p.name} className="profile-img card-img-top" />

                        <div className="display-id-overlay position-absolute top-0 start-0 m-2 px-2 py-1 rounded-pill bg-dark text-white fw-bold">
                          {p.display_id}
                        </div>

                        <div className="details-overlay position-absolute bottom-0 start-0 w-100 px-2 py-2 d-flex flex-wrap gap-1 bg-gradient-overlay">
                          <span className="cloud text-capitalize"> {p.age} yrs • {p.height}</span>
                          {/* <span className="cloud"><FaBriefcase className="me-1" />{p.current_occupation}</span> */}
                          <span className="cloud text-capitalize"> {p.current_occupation} • {p.annual_income} </span>
                          <span className="cloud text-capitalize"><FaMapMarkerAlt className="me-1" />{p.city}</span>
                          <span className="cloud text-capitalize"><FaMapMarkerAlt className="me-1" />{p.city}</span>
                          {/* <span className="cloud">Religion: <strong>{p.religion}</strong></span> */}
                        </div>
                      </div>

                      {/* <div className="profile-details text-center mt-2">
                        <Link to={`/profile/view/${p.uid}`} className="btn view-btn w-100 rounded-pill fw-semibold">
                          View Profile
                        </Link>
                      </div> */}
                    </div>
                     </Link>
                  </div>
                ))
              : (
                <div className="col-12 text-center py-5">
                  <p>No matches found yet.</p>
                </div>
              )}
        </div>
      </div>
    </div>




<div className="d-block d-lg-none">
  <PartnerCardsMobile/>
</div>




<BottomMenu/>
<FooterTwo/>

</>
  );
}

export default PartnerCards;
